const BoldText = () => (
  <>
    <path
      fill="currentColor"
      d="M8.916 18.25q-.44 0-.74-.299-.3-.3-.299-.74V6.79q0-.44.299-.74.3-.3.74-.299h3.159a3.86 3.86 0 0 1 2.529.904q1.096.903 1.096 2.352 0 .967-.508 1.693a3.06 3.06 0 0 1-1.258 1.065q.915.256 1.552 1.072t.637 1.972q0 1.61-1.202 2.526t-2.646.916zm.236-1.184h3.062q1.162 0 1.875-.7.715-.699.715-1.627 0-.93-.715-1.629-.714-.698-1.893-.698H9.152zm0-5.816h2.864q.997 0 1.69-.617.692-.618.692-1.546 0-.946-.704-1.552a2.47 2.47 0 0 0-1.667-.606H9.152z"
    />
  </>
)
export default BoldText
